// extracted by mini-css-extract-plugin
export default {"col":"doctorDashboard_col__OUnGF","container":"doctorDashboard_container__ZwuNB"};